import { IS_LOCALHOST, IS_PRODUCTION } from '~/constants/system'

/** localStorage key used to override the API server origin in non-production environments. */
export const SERVER_OVERRIDE_KEY = 'splits.server-override'

if (!process.env.SERVER_ORIGIN) {
  throw new Error('SERVER_ORIGIN is not set')
}
const serverOrigin = process.env.SERVER_ORIGIN!

const LOCAL_TESTING_HOST = 'local.splits.org'

// If this is being fetched in a server component, you should pass in the
// hostname since window.hostname is not available
export const getServerOrigin = (hostname?: string) => {
  // Allow PR environment server override (disabled in production)
  if (typeof window !== 'undefined' && !IS_PRODUCTION) {
    const override = localStorage.getItem(SERVER_OVERRIDE_KEY)
    if (override) return override
  }

  if (!IS_LOCALHOST) {
    return serverOrigin
  }

  if (typeof window === 'undefined') {
    if (hostname && hostname === LOCAL_TESTING_HOST) {
      if (!process.env.LOCAL_TESTING_SERVER_ORIGIN) {
        throw new Error('LOCAL_TESTING_SERVER_ORIGIN is not set')
      }
      return process.env.LOCAL_TESTING_SERVER_ORIGIN
    }
  } else {
    if (window.location.hostname === LOCAL_TESTING_HOST) {
      if (!process.env.LOCAL_TESTING_SERVER_ORIGIN) {
        throw new Error('LOCAL_TESTING_SERVER_ORIGIN is not set')
      }
      return process.env.LOCAL_TESTING_SERVER_ORIGIN
    }
  }

  return serverOrigin
}
